module.exports = {"620525100":"张家川镇","620525101":"龙山镇","620525102":"恭门镇","620525103":"马鹿镇","620525104":"梁山镇","620525105":"马关镇","620525106":"刘堡镇","620525107":"胡川镇","620525108":"大阳镇","620525109":"川王镇","620525202":"张棉乡","620525204":"木河乡","620525209":"连五乡","620525213":"平安乡","620525214":"阎家乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620525.json
// module id = 2913
// module chunks = 0